import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { EVENTS } from '@r1-frontend/shared/constants/analytics';
import { CATEGORIES } from '@r1-frontend/shared/constants/analytics';

import { ACTIONS } from '~/src/features/bundles/constants/analytics';

const sendSelectFilter = (): void => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.bundles,
        action: ACTIONS.clickPrivateSector,
    });
};

export default sendSelectFilter;
